import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ServicesHero from '../components/services/ServicesHero';
import ServicesList from '../components/services/ServicesList';
import ServicesCTA from '../components/services/ServicesCTA';
import SEO from '../components/SEO';
import {
  organization,
  breadcrumb,
  wrap,
  SITE_URL,
} from '../components/seo/schemas';
import { Toaster } from '../components/ui/toaster';

const PAGE_URL = `${SITE_URL}/services`;

const offerCatalog = {
  '@type': 'OfferCatalog',
  name: 'Growth Marketing Services',
  itemListElement: [
    {
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name: 'Marketing Strategy',
        description:
          'Brand strategy, messaging, competition analysis and go-to-market strategy for startups.',
      },
    },
    {
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name: 'Performance Marketing',
        description:
          'Google Adwords, Meta Ads, TikTok, LinkedIn advertising and full-funnel paid acquisition.',
      },
    },
    {
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name: 'SEO & Search Marketing',
        description:
          'Keyword analysis, on-page and off-page optimisation, performance reporting and AI Search Optimisation.',
      },
    },
    {
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name: 'Lead Generation & CRM',
        description:
          'Buyer journey mapping, content strategy, CRM-built marketing and marketing automation.',
      },
    },
    {
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name: 'Tracking and Analytics',
        description:
          'Campaign performance tracking, CRO, user behaviour analytics and product analytics setup.',
      },
    },
    {
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name: 'Content Marketing & Social Media',
        description:
          'Social media content, influencer marketing, email marketing and content strategy.',
      },
    },
    {
      '@type': 'Offer',
      itemOffered: {
        '@type': 'Service',
        name: 'Web Development',
        description:
          'Custom website design, e-commerce, web applications, CMS and maintenance.',
      },
    },
  ],
};

const structuredData = wrap([
  organization,
  breadcrumb([
    { name: 'Home', url: SITE_URL },
    { name: 'Services', url: PAGE_URL },
  ]),
  {
    '@type': 'Service',
    '@id': `${PAGE_URL}#service`,
    name: 'Growth Marketing Services',
    description:
      'End-to-end growth marketing services for startups — strategy, performance marketing, SEO, lead generation, analytics, content and web development.',
    provider: { '@id': `${SITE_URL}/#organization` },
    areaServed: ['Norway', 'India', 'United Kingdom'],
    serviceType: 'Growth Marketing',
    hasOfferCatalog: offerCatalog,
    url: PAGE_URL,
  },
]);

const ServicesPage = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="Growth Marketing Services | SEO, Performance Marketing, Analytics - Upscale Oslo"
        description="Comprehensive growth marketing services including SEO, performance marketing, content strategy, lead generation, data analytics, and web development. Google Premier Partner and HubSpot certified agency in Oslo."
        keywords="SEO services Oslo, performance marketing, Google Adwords, Meta ads, content marketing, lead generation, marketing strategy, web development, UI UX audit, brand strategy Norway, AI search optimisation"
        canonicalUrl={PAGE_URL}
        ogTitle="End-to-end Growth Marketing Services — Upscale"
        ogDescription="Strategy, SEO, performance marketing, lead gen, analytics and web dev — built for measurable results. Google Premier Partner."
        structuredData={structuredData}
      />
      <Navbar />
      <ServicesHero />
      <ServicesList />
      <ServicesCTA />
      <Footer />
      <Toaster />
    </div>
  );
};

export default ServicesPage;
